// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3ogDk","modal":"Modal_modal__2ex0P","slide-down":"Modal_slide-down__2VYNV"};